import AGREGAR_CONTRATO_INSUMO from '@/graphql/mutations/administracion/contratos/contrato/insumos/agregarContratoInsumo.gql';
import ACTUALIZAR_CONTRATO_INSUMO from '@/graphql/mutations/administracion/contratos/contrato/insumos/actualizarContratoInsumo.gql';
import REMOVER_CONTRATO_INSUMO from '@/graphql/mutations/administracion/contratos/contrato/insumos/removerContratoInsumo.gql';
import CONTRATO_INSUMOS from '@/graphql/querys/administracion/contratos/insumos/contratoInsumos.gql';
import CATALOGO_INSUMOS from '@/graphql/querys/administracion/catalogos/insumos/catalogoInsumos.gql';

export default {
  apollo: {
    catalogoInsumos: {
      query: CATALOGO_INSUMOS,
    },
  },
  methods: {
    mixGetTipoInsumo(tipo) {
      if (tipo === 1) return 'PERSONAL';
      if (tipo === 2) return 'MAQUINARIA';
      if (tipo === 3) return 'EQUIPO';
      return '';
    },
    // Agregar Contrato Insumo
    async mixAgregarContratoInsumo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_INSUMO,
          variables: {
            insumo: this.insumo,
          },
          update: (store, { data: { agregarContratoInsumo } }) => {
            const query = {
              query: CONTRATO_INSUMOS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoInsumos } = store.readQuery(query);
            const contratoInsumosCopia = contratoInsumos.slice();
            contratoInsumosCopia.push(agregarContratoInsumo);
            store.writeQuery({
              ...query,
              data: {
                contratoInsumos: contratoInsumosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Actualizar Contrato Insumo
    async mixActualizarContratoInsumo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_INSUMO,
          variables: {
            id: this.contratoInsumoEditar.id,
            insumo: this.insumo,
          },
          update: (store, { data: { actualizarContratoInsumo } }) => {
            const query = {
              query: CONTRATO_INSUMOS,
              variables: {
                idContrato: this.contratoInsumoEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoInsumos } = data;
            const index = contratoInsumos
              .findIndex((contratoInsumo) => contratoInsumo.id
                === actualizarContratoInsumo.id);
            if (index !== -1) {
              contratoInsumos.splice(index, 1, actualizarContratoInsumo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Contrato Insumo
    async mixEliminarContratoInsumo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_INSUMO,
        variables: {
          id: this.contratoInsumoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_INSUMOS,
            variables: {
              idContrato: this.contratoInsumoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoInsumos } = data;
          const index = contratoInsumos
            .findIndex((contratoInsumo) => contratoInsumo.id === this.contratoInsumoEliminar.id);
          if (index !== -1) {
            contratoInsumos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixGetCatalogoInsumos() {
      if (!this.catalogoInsumos) return [];
      return this.catalogoInsumos
        .slice()
        .map((insumo) => ({
          ...insumo,
          descripcion: `${insumo.descripcion} - (${this.mixGetTipoInsumo(insumo.tipo)})`,
        }))
        .sort((a, b) => a.tipo - b.tipo);
    },
  },
};
